export const API = 'https://conges.swavocats.com/api';

// Mapping type DB → label affiché (le type en base ne change pas)
export const TYPE_LABELS = {
  "CP":         "CP",
  "RTT":        "Congés spéciaux",
  "Maladie":    "Maladie",
  "Maternite":  "Maternité",
  "Paternite":  "Paternité",
  "Pacs":       "PACS",
  "Absence":    "Jour non travaillé",
};
export const typeLabel = (type) => TYPE_LABELS[type] || type;
